import { render, staticRenderFns } from "./FireTablePagination.vue?vue&type=template&id=19b22d96&scoped=true&"
import script from "./FireTablePagination.vue?vue&type=script&lang=js&"
export * from "./FireTablePagination.vue?vue&type=script&lang=js&"
import style0 from "./FireTablePagination.vue?vue&type=style&index=0&id=19b22d96&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b22d96",
  null
  
)

export default component.exports